import React from "react";
import LocationPendingPayment from "./LocationPendingPayment";

const LocationPendingPaymentTab = ({
  locationPendingPaymentArray,
  i18n,
  renderNoResultsFound,
  closeModal
}) => {

  return (
    <div>
      {locationPendingPaymentArray
        ? <LocationPendingPayment
            locationPendingPaymentArray={locationPendingPaymentArray}
            i18n={i18n}
          />
        : renderNoResultsFound()}
    </div>
  );
};

export default LocationPendingPaymentTab;
